import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase';
import PublicHeader from '../components/layout/PublicHeader';
import LeagueLeaderboard from '../components/LeagueLeaderboard';

export default function LeaguePage() {
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    return onAuthStateChanged(auth, user => setCurrentUser(user ?? null));
  }, []);

  if (currentUser === undefined) return null;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0A0E1A' }}>
      <PublicHeader />
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '32px 16px' }}>
        <LeagueLeaderboard currentUserId={currentUser?.uid} />
      </div>
    </div>
  );
}
